import type { Peer } from "@circle-react/types/Live/Peer";
import { useHMSPeerVideo } from "../hms";
import { useLivekitPeerVideo } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeerVideo = (peer?: Peer) =>
  useProviderHook({
    hms: useHMSPeerVideo,
    livekit: useLivekitPeerVideo,
  })(peer);
